import { z } from 'zod';
import { moneySchema } from '../money';
import { purchaseOrderStatusSchema, type PurchaseOrderStatus } from './purchase-order.schema';

/**
 * „Offen" im Einkauf: Entwurf oder bestellt — Dashboard-Kachel „Offene
 * Bestellungen", Analyse „Offenes Bestellvolumen".
 */
export const OPEN_PURCHASE_ORDER_STATUSES = ['DRAFT', 'ORDERED'] as const satisfies readonly PurchaseOrderStatus[];

/**
 * Einkaufs-Kennzahlen über ALLE Einkaufsbelege der Standardliste (alle
 * Belegarten, ohne Bestellpool) — `GET /v1/purchase-orders/summary`,
 * Analyse-Cockpit. Serverseitig gerechnet (2026-09-29); vorher zählte der
 * Browser die erste Listenseite (100 bzw. 500 Belege).
 */
export const purchaseOrderSummarySchema = z.object({
  asOf: z.string().datetime(),
  /** Alle Belege der Standardliste (ohne Bestellpool). */
  total: z.number().int().nonnegative(),
  /** Davon Entwurf oder bestellt. */
  open: z.number().int().nonnegative(),
  /** Anzahl je Status (nur belegte Status, in Status-Reihenfolge). */
  byStatus: z.array(z.object({ status: purchaseOrderStatusSchema, count: z.number().int().positive() })),
  /** Netto-Summe der offenen Belege (Entwurf/bestellt) — „offenes Bestellvolumen". */
  openNet: moneySchema,
});
export type PurchaseOrderSummary = z.infer<typeof purchaseOrderSummarySchema>;
